import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ExportarDropboxService } from '../services/exportar-dropbox.service';


@Injectable({
  providedIn: 'root'
})
export class ListExecutionResolver implements Resolve<boolean> {

  constructor(private service: ExportarDropboxService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.listExecution();
  }
}